import styled from "styled-components";
import { theme } from "../../../helpers/theme";
import { ImageSection } from "../faq/components/imageSection";
import { ImageSection_ } from "../faq/components/imageSection_";
const title = `Regulamin`;
const subtitle = `Lorem ipsum dolor sit amet.`;
const text1 = `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.`
const text2 = ` Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum`;

export const Regulations = () => {
    return (
        <PageContainer>
            <PageTitle>{title}</PageTitle>
            <Subtitle>{subtitle}</Subtitle>
            <Text>
                {text1}<br /><br />
                {text2}
            </Text>

            <Subtitle>{subtitle}</Subtitle>
            <Text>
                {text1}<br /><br />
                {text2}
            </Text>

            <Subtitle>{subtitle}</Subtitle>
            <Text>
                {text1}<br /><br />
                {text2}
            </Text>

            {/* <ImageSection /> */}
            <ImageSection_ />
        </PageContainer >
    );
};

const PageContainer = styled.div`
padding: 20px 10px;
display: flex;
flex-direction: column;
`;

const PageTitle = styled.h2`
width:100%;
color:${theme.colors.black_primaryText};
font-family: ${theme.fonts.interBold};
font-style: normal;
font-weight: ${theme.fontWeight.big};
font-size: 32px;
line-height: 40px;
margin:0px;
padding-bottom:33px;
`
const Subtitle = styled.p`
font-family:${theme.fonts.interBold};
font-weight: ${theme.fontWeight.big};
font-size: 16px;
line-height: 24px;
color:${theme.colors.black_primaryText};
margin:0px;
`
const Text = styled.p`
font-family:${theme.fonts.interRegular};
font-weight: ${theme.fontWeight.small};
font-size: 16px;
line-height: 24px;
color:${theme.colors.black_primaryText};
margin:0px 0px 24px;
`